// SPDX-License-Identifier: BUSL-1.1

/**
 * TenantSettingsSkeleton — loading skeleton for the tenant settings page.
 *
 */

import { Skeleton } from '@/components/ui/skeleton';
import { Card } from '@/components/ui/card';

export function TenantSettingsSkeleton() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <Skeleton className="h-8 w-52" />
      <Card className="flex flex-col gap-4 p-6">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-10 w-full rounded-lg" />
        <Skeleton className="h-5 w-28" />
        <Skeleton className="h-10 w-full rounded-lg" />
        <div className="flex gap-3 pt-2">
          <Skeleton className="h-9 w-28 rounded" />
          <Skeleton className="h-9 w-20 rounded" />
        </div>
      </Card>
    </div>
  );
}
